export default __webpack_public_path__ + "static/brand-16-eeebd8ada4de2e57a67380dc6a686581.png";